module.exports = __webpack_public_path__ + "img/2.d1d853d2.png";